import { render, staticRenderFns } from "./MentorSnippet.vue?vue&type=template&id=09d69cb3&scoped=true"
import script from "./MentorSnippet.vue?vue&type=script&lang=js"
export * from "./MentorSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d69cb3",
  null
  
)

export default component.exports